import 'twin.macro';
import ContentPrismicSlice from '@leuven2030/framework/Content/ContentPrismicSlice';

const ContentPrismic = ({ SliceComponents = [], slices, ...rest }) => {
  slices = slices || [];

  return (
    <div {...rest} tw="space-y-6">
      {slices.map((props, index) => {
        return (
          <ContentPrismicSlice
            SliceComponents={SliceComponents}
            key={index}
            {...props}
          />
        );
      })}
    </div>
  );
};

export default ContentPrismic;
